import gsap from 'gsap';

class Accordion {
  constructor(el) {
    this.el = el;
    this.accordionItems = this.el.children;
    this.isAnim = false;
    this.toggle = this.toggle.bind(this);
    this.onAnimationComplete = this.onAnimationComplete.bind(this);
    this.init();
  }

  init() {
    Array.from(this.accordionItems).forEach((element) => {
      const button = element.querySelector('[data-accordion-button]');
      if (button) {
        button.addEventListener('click', this.toggle);
      }
    });
  }

  toggle(event) {
    const { currentTarget } = event;
    const open = currentTarget.getAttribute('aria-controls');
    if (open) {
      const externalAccordion = document.querySelector(
        `[data-accordion="${open}"]`
      );
      if (externalAccordion) {
        const button = externalAccordion.querySelector(
          '[data-accordion-button]'
        );
        if (button) {
          button.click();
        }
      }
    }
    const activeItem = this.el.querySelector('.js--active');
    const activeContent = activeItem ? activeItem.children[1] : null;
    const content = currentTarget.nextElementSibling;
    if (this.isAnim) {
      return;
    }
    this.isAnim = true;
    const normalizedHeight = gsap.utils.normalize(
      0,
      500,
      content.children[0].offsetHeight
    );
    const duration = gsap.utils.clamp(0.3, 1, normalizedHeight);
    if (content === activeContent) {
      gsap.to(content, {
        height: '0px',
        duration,
        onComplete: this.onAnimationComplete,
        onCompleteParams: [content.parentElement],
      });
      return;
    }
    if (activeContent) {
      gsap.to(activeContent, {
        height: '0px',
        duration,
      });
    }
    gsap.set(content, { css: { height: '0px' } });
    gsap.to(content, {
      height: content.children[0].offsetHeight,
      duration,
      onComplete: this.onAnimationComplete,
      onCompleteParams: [activeItem, content],
    });
  }

  onAnimationComplete(activeItem, content) {
    if (activeItem) {
      activeItem.classList.remove('js--active');
    }
    if (content) {
      content.removeAttribute('style');
      content.parentElement.classList.add('js--active');
    }
    this.isAnim = false;
  }
}

export default Accordion;
